module.exports = __webpack_public_path__ + "static/media/chevronLeft.0cbcdc0d.svg";